import { LegalLayout, Section } from "@/components/legal/LegalLayout";

export default function DataDeletion() {
  return (
    <LegalLayout title="Eliminazione dei dati" updated="giugno 2026" testid="data-deletion-page">
      {(b) => {
        const mail = `mailto:${b.company_email}?subject=${encodeURIComponent("Richiesta eliminazione dati WhatsApp")}`;
        return (
          <>
            <Section title="Come richiedere l'eliminazione">
              <ol className="list-decimal pl-5 space-y-2">
                <li><b>Via WhatsApp:</b> scrivici al nostro numero il messaggio <code className="bg-slate-100 px-1.5 py-0.5 rounded">ELIMINA I MIEI DATI</code>.</li>
                <li><b>Via email:</b> scrivi a <a className="text-[#15803D] font-semibold" href={mail} data-testid="deletion-email-link">{b.company_email}</a> indicando il numero di telefono WhatsApp usato con noi.</li>
              </ol>
            </Section>
            <Section title="Cosa eliminiamo">
              <p>Entro <b>30 giorni</b> dalla richiesta cancelliamo: conversazioni, allegati (foto, documenti, note vocali), dati di contatto e valutazioni associati al tuo numero. Ti confermiamo l'avvenuta cancellazione via WhatsApp o email.</p>
              <p>Possiamo conservare solo i dati che la legge ci obbliga a tenere (ad esempio documenti fiscali).</p>
            </Section>
            <Section title="Dati presso Meta / WhatsApp">
              <p>Il tuo account WhatsApp e i dati gestiti da Meta non dipendono da noi: per eliminarli usa l'app WhatsApp (Impostazioni → Account → Elimina account) oppure consulta l'informativa di WhatsApp.</p>
            </Section>
            <Section title="English">
              <p>To delete your data, send "DELETE MY DATA" to our WhatsApp number or email {b.company_email} with your WhatsApp phone number. We delete conversations, attachments, contact details and ratings within 30 days and confirm by message.</p>
            </Section>
          </>
        );
      }}
    </LegalLayout>
  );
}
